import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Avatar, Caption, Title, useTheme } from 'react-native-paper';
import { useSessao } from '../../redux/sessao/sessaoHooks';
import { SessaoState } from '../../redux/sessao/sessaoTypes';
import { celularMask } from '../../shared/helper';

// import { AuthContext } from '../components/context';
type Props = {};

export const UserInfo: React.FC<Props> = (props) => {
  const [sessao, login, logout] = useSessao();

  if (!sessao.token || !sessao.cliente || !sessao.cliente.nome) {
    logout();
    return null;
  }

  return (
    <View style={styles.userInfoSection}>
      <View style={{ flexDirection: 'row', marginTop: 15 }}>
        <Avatar.Text label={sessao.cliente.nome[0].toUpperCase()} size={50} />
        <View style={{ marginLeft: 15, flexDirection: 'column', flex: 1 }}>
          <Title style={styles.title}>{sessao.cliente.nome}</Title>
          <Caption style={styles.caption}>{celularMask(sessao.cliente.celular)}</Caption>
        </View>
      </View>

      {/* <View style={styles.row}>
        <View style={styles.section}>
          <Paragraph style={[styles.paragraph, styles.caption]}>80</Paragraph>
          <Caption style={styles.caption}>Following</Caption>
        </View>
        <View style={styles.section}>
          <Paragraph style={[styles.paragraph, styles.caption]}>100</Paragraph>
          <Caption style={styles.caption}>Followers</Caption>
        </View>
      </View> */}
    </View>
  );
};

const styles = StyleSheet.create({
  userInfoSection: {
    paddingLeft: 20
  },
  title: {
    fontSize: 16,
    marginTop: 3,
    fontWeight: 'bold'
  },
  caption: {
    fontSize: 14,
    lineHeight: 14
  }
});

export default UserInfo;
